<template>
  <b-card
    class="fadeIn card-radius m-0"
    :class="[cardClass, { 'overflow-hidden': !expanded }]"
    :header-class="['row-radius', headerClass]"
    footer-class="row-bottom-radius"
    body-class="p-0 mt-n1"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between user-select-none"
      >
        <div
          class="d-flex align-items-center"
          :class="{ 'cursor-pointer': collapsable && !disableToggle }"
          @click="!disableToggle ? toggle() : null"
        >
          <font-awesome-icon v-if="icon" :icon="icon" :size="iconSize" />

          <h4 class="p-0 my-0 mx-2">{{ title }}</h4>

          <slot name="header-right"></slot>
        </div>

        <div class="d-flex align-items-center">
          <slot name="header-left"></slot>

          <b-btn
            v-if="collapsable"
            variant="transparent"
            :class="[
              'd-print-none py-0 px-2 m-0 no-outline',
              toggleButtonClass
            ]"
            :disabled="disableToggle"
            @click="toggle"
          >
            <font-awesome-icon :icon="`chevron-${expanded ? 'up' : 'down'}`" />
          </b-btn>
        </div>
      </div>
    </template>

    <b-collapse v-model="expanded" :class="collapseClass">
      <b-overlay
        :show="loading"
        blur="1rem"
        opacity="0.6"
        rounded="lg"
        variant="transparent"
        class="h-100"
      >
        <div :class="containerClass">
          <slot></slot>
        </div>
      </b-overlay>
    </b-collapse>

    <template v-if="$slots.footer" #footer>
      <slot name="footer"></slot>
    </template>
  </b-card>
</template>

<script>
export default {
  name: 'BrbCard',
  props: {
    loading: Boolean,
    title: String,
    icon: String,
    iconSize: {
      type: String,
      default: 'lg'
    },
    collapsable: Boolean,
    collapsed: Boolean,
    disableToggle: Boolean,
    headerClass: {
      type: [String, Array, Object],
      default: 'card-header-blue-gray'
    },
    toggleButtonClass: {
      type: [String, Array, Object],
      default: 'text-white'
    },
    collapseClass: {
      type: [String, Array, Object]
    },
    cardClass: {
      type: [String, Array, Object]
    },
    containerClass: {
      type: [String, Array, Object],
      default: 'p-3'
    }
  },
  data() {
    return {
      expanded: !this.collapsed
    }
  },
  methods: {
    toggle() {
      if (this.collapsable) this.expanded = !this.expanded
    },
    collapse() {
      this.expanded = false
    },
    expand() {
      this.expanded = true
    }
  }
}
</script>
